import { Component } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-document-delete',
  templateUrl: './document-delete.component.html',
  styleUrls: ['./document-delete.component.scss'],
  standalone: false,
})
export class DocumentDeleteComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly reasons = [
    { label: translate('documents.delete.spam'), value: 'spam' },
    { label: translate('documents.delete.duplicate'), value: 'duplicate' },
    { label: translate('documents.delete.bad-extraction'), value: 'bad-extraction' },
    { label: translate('documents.delete.other'), value: '' },
  ];

  deleteReason: string;

  constructor(private dialogRef: MatDialogRef<DocumentDeleteComponent>) {}

  cancel() {
    this.dialogRef.close(undefined);
  }

  confirm() {
    this.dialogRef.close(this.deleteReason);
  }
}
